/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import linearGradient from "assets/theme/functions/linearGradient";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, miniSidenav } = ownerState;

  const sidebarWidth = 250;
  const { transparent, gradients } = palette;
  const { xxl } = boxShadows;
  const { pxToRem } = functions;

  // styles for the sidenav when miniSidenav={false} (open state)
  const drawerOpenStyles = () => ({
    transform: "translateX(0)",
    // Base transition (mobile & default)
    transition: "transform 0.25s ease-out",

    [breakpoints.down("xl")]: {
      // Mobile: show from left
      transform: "translateX(0)",
      width: sidebarWidth,
      zIndex: 1300,
    },

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      // IMPORTANT: include `transform` in the transition list on desktop
      transition: transitions.create(["transform", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true} (closed / hidden state)
  const drawerCloseStyles = () => ({
    transform: `translateX(${pxToRem(-320)})`,
    // Smooth slide-out animation
    transition: "transform 0.25s ease-in",

    [breakpoints.down("xl")]: {
      // Mobile: hide completely
      transform: `translateX(${pxToRem(-320)})`,
    },

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: pxToRem(250),
      overflowX: "hidden",
      transform: `translateX(${pxToRem(-250)})`,
      transition: transitions.create(["transform", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: xxl,
      border: "1px solid rgba(255, 255, 255, 0.1)",
      background: transparentSidenav
        ? "rgba(17, 25, 40, 0.15)"
        : "rgba(17, 25, 40, 0.15)",
      backdropFilter: "blur(4px) saturate(180%)",
      WebkitBackdropFilter: "blur(4px) saturate(180%)",
      backgroundColor: "rgba(17, 25, 40, 0.15)",
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
